var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreditCardIc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 37,
    viewBox: "0 0 49 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 0L48.1025 0.00488281C48.6067 0.0562144 49 0.482323 49 1V35.0713C49 35.6236 48.5523 36.0713 48 36.0713H1C0.447715 36.0713 0 35.6236 0 35.0713V1C0 0.447715 0.447715 0 1 0H48ZM2 34.0713H47V13.3574H2V34.0713ZM16.1074 26.5L16.209 26.5049C16.7134 26.5559 17.1074 26.9821 17.1074 27.5C17.1074 28.0179 16.7134 28.4441 16.209 28.4951L16.1074 28.5H6.03613C5.48385 28.5 5.03613 28.0523 5.03613 27.5C5.03613 26.9477 5.48385 26.5 6.03613 26.5H16.1074ZM12.75 20.8213C13.3022 20.8213 13.7499 21.2691 13.75 21.8213C13.75 22.3736 13.3023 22.8213 12.75 22.8213H6.03613C5.48385 22.8213 5.03613 22.3736 5.03613 21.8213C5.03621 21.2691 5.48389 20.8213 6.03613 20.8213H12.75ZM2 11.3574H47V9.57129H2V11.3574ZM2 7.57129H47V2H2V7.57129Z",
    fill: "url(#paint0_linear_86_293)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_86_293",
    x1: 24.5,
    y1: 0,
    x2: 24.5,
    y2: 36.0713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AA0FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8EDFCE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardIc);
export default __webpack_public_path__ + "static/media/credit-card-ic.02f7f4d6479e876f0524db5179101871.svg";
export { ForwardRef as ReactComponent };